var exports = {
  "d1": "TagLabel__lE3aTQ",
  "d7": "TagsContainer__ibat_C",
  "BG": "ListItemContainer__rSdxmG",
  "Ct": "ListItemTitleLabel__LJhlLj",
};

module.exports = exports;
